<template>
  <div class="scan-stub">
    <p>
      Данный QR-код предназначен для использования приложением <nobr>АИС «РМЛ РАС»</nobr>.
      Отсканируете код через мобильное приложение Организации.
    </p>
  </div>
</template>

<script>
export default {
  name: "ScanStub",
};
</script>

<style scoped lang="scss">
@import '/src/assets/theme/default/colors.scss';

.scan-stub {
  color: $black;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.45;
  text-align: center;
}

.scan-stub p {
  margin: 0;
}
</style>
